import * as React from "react";
import { DataLayer, AlgoliaAnalyticsHelpers } from "@grandvisionhq/analytics";
import { CheckboxWithLabel } from "@grandvisionhq/forms";
import { Icon } from "@grandvisionhq/icons";
import { useIntl } from "@grandvisionhq/state";
import { useAlgoliaConfig } from "../../../../../Algolia/AlgoliaConfig.js";
import { getFacetOptionLabel } from "../../../../../utils/Algolia/utils/get-facet-option-label.js";
/* empty css                    */
const Label = ({ icon, label, count }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { className: "refinement-item__value", "data-t": "facet-item-value" }, icon && /* @__PURE__ */ React.createElement(Icon, { name: icon }), " ", label), /* @__PURE__ */ React.createElement("span", { className: "refinement-item__count" }, count));
const RefinementItem = ({ item, facet, onRefine, onChange }) => {
  const intl = useIntl();
  const { indexName } = useAlgoliaConfig();
  const { icon, label } = React.useMemo(
    () => getFacetOptionLabel(facet, item.label, intl),
    [facet, item, intl]
  );
  const handleChange = React.useCallback(() => {
    onRefine(item.value);
    onChange && onChange();
    DataLayer.pushEvent(createFilterApplied(intl.getLabel(facet.labelKey || ""), item.value));
    const encodedAttribute = encodeURIComponent(facet.attribute);
    const encodedValue = encodeURIComponent(item.value);
    const filterString = `${encodedAttribute}:${encodedValue}`;
    AlgoliaAnalyticsHelpers.sendFilterAppliedEvent([filterString], indexName);
  }, [facet.labelKey, facet.attribute, intl, item.value, onChange, onRefine, indexName]);
  return /* @__PURE__ */ React.createElement("span", { className: "refinement-item" }, /* @__PURE__ */ React.createElement(
    CheckboxWithLabel,
    {
      className: "refinement-item__checkbox",
      checked: item.isRefined,
      value: item.label,
      onChange: handleChange,
      label: /* @__PURE__ */ React.createElement(Label, { count: item.count, label, icon })
    }
  ));
};
const createFilterApplied = (facetLabel, option) => {
  return {
    event: "filter_applied",
    filter_type: facetLabel,
    filter_value: option
  };
};
export {
  RefinementItem as default
};
//# sourceMappingURL=RefinementItem.js.map
